import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { getTheme } from '../../../src/theme/getTheme'

// Design-system colors for create page
const C = {
  cardBg: '#1A1233',
  border: '#2A1F44',
  primary: '#A78BFA',
  textDefault: '#F7FAFC',
  textDim: '#9CA3AF',
  textMuted: '#6B7280',
  pillBg: 'rgba(167,139,250,0.12)',
} as const

export const getCreateGamesStepStyles = (_theme: Theme) =>
  StyleSheet.create({
    stepWrapper: {
      flex: 1,
    },
    leagueSection: {
      marginBottom: 10,
    },
    /** Sport section break — sits above league headers (specs/multi-sport-challenges). */
    sportDivider: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginTop: 18,
      marginBottom: 6,
      paddingHorizontal: 4,
    },
    sportDividerLabel: {
      fontSize: 12,
      fontWeight: '800' as const,
      letterSpacing: 1.1,
      color: C.textDefault,
    },
    sportDividerRule: {
      flex: 1,
      height: 1,
      backgroundColor: C.border,
    },
    sportDividerCount: {
      fontSize: 11,
      fontWeight: '700' as const,
      color: C.textMuted,
    },
    leagueHeaderContainer: {
      borderRadius: 10,
      marginBottom: 6,
      overflow: 'visible',
    },
    leagueHeader: {
      paddingHorizontal: 12,
      paddingVertical: 7,
      borderRadius: 12,
      backgroundColor: C.cardBg,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
      overflow: 'hidden',
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 2px 4px rgba(0,0,0,0.4)' as const }
        : {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.4,
            shadowRadius: 4,
            elevation: 3,
          }),
    },
    leagueHeaderAccent: {
      position: 'absolute',
      left: 0,
      top: 6,
      bottom: 6,
      width: 3,
      backgroundColor: C.primary,
      borderRadius: 9999,
    },
    leagueHeaderContent: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    leagueHeaderCollapseButton: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    leagueStarButton: {
      marginRight: 0,
      padding: 2,
      justifyContent: 'center',
      alignItems: 'center',
    },
    leagueHeaderFlagWrap: {
      justifyContent: 'center',
    },
    leagueTitle: {
      fontSize: 12,
      fontWeight: '700' as const,
      color: C.textDefault,
      flex: 1,
    },
    leagueMatchCount: {
      fontSize: 10,
      fontWeight: '700' as const,
      color: C.primary,
      backgroundColor: C.pillBg,
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 9999,
    },
    leagueChevron: {
      fontSize: 16,
      fontWeight: '600' as const,
      color: C.primary,
      marginLeft: 4,
    },
    gamesContainer: {
      paddingTop: 0,
      paddingHorizontal: 0,
      gap: 5,
    },
    gameContainer: {
      // kept for skeleton compatibility
    },
    showMoreButton: {
      backgroundColor: C.cardBg,
      borderRadius: 8,
      paddingVertical: 12,
      paddingHorizontal: 16,
      alignItems: 'center' as const,
      marginTop: 4,
      borderWidth: 1,
      borderColor: C.border,
    },
    showMoreButtonPressed: {
      opacity: 0.7,
    },
    showMoreText: {
      fontSize: 14,
      color: C.primary,
      fontWeight: '600' as const,
    },
    leagueStarButtonPressed: {
      opacity: 0.7,
    },
    emptyContainer: {
      padding: 24,
      alignItems: 'center' as const,
      backgroundColor: C.cardBg,
      borderRadius: 16,
      marginHorizontal: 4,
      borderWidth: 1,
      borderColor: C.border,
    },
    emptyTitle: {
      color: C.textDefault,
      fontSize: 17,
      fontWeight: '700' as const,
      marginBottom: 8,
      textAlign: 'center' as const,
    },
    emptySubtitle: {
      color: C.textDim,
      fontSize: 14,
      textAlign: 'center' as const,
    },
    emptyHint: {
      color: C.textMuted,
      fontSize: 12,
      marginTop: 10,
      textAlign: 'center' as const,
    },
  })

export const createGamesStepStyles = getCreateGamesStepStyles(getTheme('dark'))
